<template>
  <div>
    <div style="text-align: center">
      <h2 v-if="listAspects.length === 0">{{ $t('categoryEmpty') }}</h2>
    </div>
    <div v-for="(aspectLocal, index) in listAspects" :key="index + 100">
      <div
        class="grid-local totalh"
        v-for="(aspect, index) in aspectLocal"
        :key="index + 900"
      >
        <div class="grid-title totalh">
          <div></div>
          <div>{{ aspect.name }}</div>
          <div></div>
        </div>
        <div class="totalh grid-title">
          <div></div>
          <div>
            <div
              v-for="(item, index) in aspect.view"
              class="grid-half"
              :key="index + 300"
            >
              <div class="grid-title">
                <div></div>
                {{ item.name }}
                <div></div>
              </div>
              <div
                v-if="item.typeScore === 'checkbox'"
                class="grid-title checkbox"
              >
                <div></div>
                <v-checkbox :disabled="true"></v-checkbox>
                <div></div>
              </div>
              <div
                v-if="item.typeScore === 'textbox'"
                class="grid-title textarea"
              >
                <div></div>
                <label class="textarea">
                  <input value="" disabled />
                </label>
                <div></div>
              </div>
              <div v-if="item.typeScore === 'select'" class="grid-title select">
                <div></div>
                <v-select :disabled="true"></v-select>
                <div></div>
              </div>
              <div v-else-if="item.typeScore === 'options'">
                <v-radio-group :disabled="true">
                  <template v-for="option in item.options">
                    <v-radio
                      :label="option.value + ' - ' + option.name"
                      color="primary"
                      :value="option.value"
                      :key="option._id"
                    ></v-radio>
                  </template>
                </v-radio-group>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabIndividual',
  props: {
    aspects: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      listAspects: []
    }
  },
  watch: {
    aspects: function(val) {
      this.listAspects = val
    }
  },
  mounted() {
    this.listAspects = this.aspects
  }
}
</script>

<style scoped>
.totalh {
  /*height: 60vh;*/
}

.grid-local {
  display: grid;
  grid-template-columns: 200px 1fr;
  max-width: 95%;
  margin: auto;
  border-bottom: 1px solid #ababab;
  padding-top: 20px;
  padding-bottom: 20px;
}

.grid-title {
  display: grid;
  grid-template-rows: 1fr auto 1fr;
}

.grid-half {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
<style>
.textarea {
  resize: none;
  height: 35px;
  width: 100%;
  border: 1px solid #919191;
}
</style>
